import React, { Component } from 'react';
import { Container, Row, Col, Section } from '../../legacy/hui/src/styled';
import logo from '../images/hipages-logo.svg';
import logoSmall from '../images/hipages-logo-small.svg';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const SectionBunnings = Section.extend`
  min-height: 42px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 63px;
  }
`;

export const TitleBarWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0;
  height: 42px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    height: 63px;
  }
`;

export const TitleName = styled.div`
  color: #0d5257;
  font-size: 14px;
  line-height: 20px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 30px;
    line-height: 36px;
  }
`;

export const Logo = styled.div`
  width: 65px;
  height: 23px;
  background: url(${logoSmall}) no-repeat;
  text-indent: -99999px;
  display: inline-block;
  background-size: contain;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    background: url(${logo}) no-repeat;
    width: 104px;
    height: 38px;
    background-size: contain;
  }
`;

export const PowerBy = styled.div`
  color: #a1a1a3;
  font-size: 10px;
  line-height: 14px;
  padding-right: 5px;
  padding-top: 2px;
  @media (min-width: ${props => props.theme.breakpoints.md}rem) {
    font-size: 14px;
    line-height: 20px;
    padding-right: 12px;
  }
`;

export class TitleBar extends Component {
  static propTypes = {
    pageTitle: PropTypes.string
  };
  render() {
    const { pageTitle } = this.props;
    return (
      <div>
        <SectionBunnings>
          <Container>
            <Row>
              <Col xs={6}>
                <TitleBarWrapper>
                  <TitleName>{pageTitle}</TitleName>
                </TitleBarWrapper>
              </Col>
              <Col xs={6}>
                <TitleBarWrapper style={{ justifyContent: 'flex-end' }}>
                  <PowerBy>Powered by</PowerBy>
                  <Logo />
                </TitleBarWrapper>
              </Col>
            </Row>
          </Container>
        </SectionBunnings>
      </div>
    );
  }
}
